// src/Pages/About.js
import React from "react";
import Header from "../Includes/Header";
import Footer from "../Includes/Footer";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

const About = () => {
  const containerStagger = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1,
      },
    },
  };

  // The animation for text moving up
  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { duration: 0.6, ease: "easeOut" } 
    },
  };

  // Animation for the main image sliding in from the right
  const fadeInRight = {
    hidden: { opacity: 0, x: 50 },
    visible: { 
      opacity: 1, 
      x: 0, 
      transition: { duration: 0.8, ease: "easeOut", delay: 0.2 } 
    },
  };

  // Animation for decorative floating bubbles/shapes
  const popIn = {
    hidden: { opacity: 0, scale: 0.5 },
    visible: { 
      opacity: 1, 
      scale: 1, 
      transition: { duration: 0.5, type: "spring", bounce: 0.4 } 
    },
  };
  return (
    <div className="about-page">
      <Header />

      
      {/* Hero Section */}
   

<section
  className="mr_page_page_title page-title"
  style={{
    position: "relative",
    backgroundImage: `url('/about-banner.jpg')`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    height: "320px",
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
  }}
>
  {/* Overlay */}
  <div
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.45)",
    }}
  ></div>

  <motion.div
    className="auto-container"
    style={{ position: "relative", zIndex: 2 }}
    initial={{ opacity: 0, y: 60 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 1, ease: "easeOut" }}
  >
    <div className="content-box">
      <h1
        className="mr_banner_title mr_xpage"
        style={{
          color: "#fff",
          fontSize: "48px",
          fontWeight: "700",
          textShadow: "0 3px 6px rgba(0,0,0,0.6)",
        }}
      >
        About Us
      </h1>
    </div>
  </motion.div>
</section>


      {/* sidebar-page-container */}
      <section className=" sidebar-page-container  ">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="content-side col-12">
              <div className="wp-style">
                <div className="text">
                  <div
                    data-elementor-type="wp-page"
                    data-elementor-id={1587}
                    className="elementor elementor-1587"
                  >
                   <section
      className="elementor-section elementor-top-section elementor-element elementor-element-28275ac elementor-section-boxed elementor-section-height-default elementor-section-height-default"
      data-id="28275ac"
      data-element_type="section"
      data-settings='{"background_background":"classic"}'
    >
      <div className="elementor-container elementor-column-gap-no">
        
        {/* --- LEFT COLUMN (TEXT CONTENT) --- */}
        <motion.div
          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b1753f0"
          data-id="b1753f0"
          data-element_type="column"
          // Activate the stagger effect when this column comes into view
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={containerStagger}
        >
          <div className="elementor-widget-wrap elementor-element-populated">
            
            {/* 1. Small Title "About Us" */}
            <motion.div
              className="elementor-element elementor-element-48df556c elementor-widget elementor-widget-heading"
              variants={fadeUp}
            >
              <div className="elementor-widget-container">
                <h2 className="elementor-heading-title elementor-size-default">
                  <span className="">About us</span>
                </h2>
              </div>
            </motion.div>

            {/* 2. Main Heading */}
            <motion.div
              className="elementor-element elementor-element-470b3b1a elementor-widget elementor-widget-heading"
              variants={fadeUp}
            >
              <div className="elementor-widget-container">
                <h2 className="elementor-heading-title elementor-size-default">
                  Welcome to Green Circle Environment
                </h2>
              </div>
            </motion.div>

            {/* 3. Text Paragraph */}
            <motion.div
              className="elementor-element elementor-element-15541e7d elementor-widget elementor-widget-text-editor"
              variants={fadeUp}
            >
              <div className="elementor-widget-container">
                Green Circle Environment Pvt. Ltd. is an Indian
                incorporated and locally owned company offering
                engineering, road construction, public works,
                and project management services. We provide
                advanced technology solutions for
                municipalities, especially in the field of waste
                management. Our expertise extends across major
                industrial sectors through the design,
                installation, and commissioning of ETP, STP,
                recycling, and bio-gas plants.
              </div>
            </motion.div>

            {/* 4. Icon List */}
            <motion.div
              className="elementor-element elementor-element-3db30b23 elementor-align-left icon_wastix elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
              variants={fadeUp}
            >
              <div className="elementor-widget-container">
                <ul className="elementor-icon-list-items">
                  <li className="elementor-icon-list-item">
                    <a href="#">
                      <span className="elementor-icon-list-icon">
                        <svg aria-hidden="true" className="e-font-icon-svg e-fas-check" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                          <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" />
                        </svg>
                      </span>
                      <span className="elementor-icon-list-text">Innovative Waste Solutions</span>
                    </a>
                  </li>
                  <li className="elementor-icon-list-item">
                    <a href="#">
                      <span className="elementor-icon-list-icon">
                        <svg aria-hidden="true" className="e-font-icon-svg e-fas-check" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                          <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" />
                        </svg>
                      </span>
                      <span className="elementor-icon-list-text">Engineering & Construction Services</span>
                    </a>
                  </li>
                  <li className="elementor-icon-list-item">
                    <a href="#">
                      <span className="elementor-icon-list-icon">
                        <svg aria-hidden="true" className="e-font-icon-svg e-fas-check" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                          <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" />
                        </svg>
                      </span>
                      <span className="elementor-icon-list-text">Recycling & Recovery Systems</span>
                    </a>
                  </li>
                </ul>
              </div>
            </motion.div>

            {/* 5. Button */}
            <motion.div
              className="elementor-element elementor-element-380e0892 wastix_btn_01 elementor-widget elementor-widget-button"
              variants={fadeUp}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <div className="elementor-widget-container">
                <div className="elementor-button-wrapper">
                  <Link className="elementor-button elementor-button-link elementor-size-sm" to="/contact-us">
                    <span className="elementor-button-content-wrapper">
                      <span className="elementor-button-text">Contact Us</span>
                    </span>
                  </Link>
                </div>
              </div>
            </motion.div>

          </div>
        </motion.div>

        {/* --- RIGHT COLUMN (IMAGES) --- */}
        <div
          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1b035 wastix_animation_block_01"
          data-id="1b035"
          data-element_type="column"
        >
          <div className="elementor-widget-wrap elementor-element-populated">
            
            {/* Small shape top left - Pops in */}
            <motion.div
              className="elementor-element elementor-element-565ffd58 elementor-absolute wastix_img_animation_01 elementor-hidden-tablet elementor-hidden-mobile elementor-widget elementor-widget-image"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={popIn}
            >
              <div className="elementor-widget-container">
                <img decoding="async" width={180} height={180} src="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-3.png" className="attachment-large size-large wp-image-143" alt="" />
              </div>
            </motion.div>

            {/* MAIN IMAGE - Slides in from Right */}
            <motion.div
              className="elementor-element elementor-element-799d6f41 wastix_bg_animation_02 elementor-widget elementor-widget-image"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInRight}
            >
              <div className="elementor-widget-container">
                <img decoding="async" width={470} height={650} src="/containimg_25.png" className="attachment-large size-large wp-image-117" alt="" />
              </div>
            </motion.div>

            {/* Floating Image 1 - Slides Up/Pops */}
            <motion.div
              className="elementor-element elementor-element-3531fa6f elementor-absolute wastix_bg_animation_01 elementor-widget__width-auto elementor-widget elementor-widget-image"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              <div className="elementor-widget-container">
                <img loading="lazy" decoding="async" width={290} height={180} src="/containimg_50.jpeg" className="attachment-large size-large wp-image-133" alt="" />
              </div>
            </motion.div>

            {/* Floating Image 2 - Pops in late */}
            <motion.div
              className="elementor-element elementor-element-d7e95f3 elementor-absolute wastix_bg_animation_01 elementor-widget__width-auto elementor-widget elementor-widget-image"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={popIn}
            >
              <div className="elementor-widget-container">
                <img loading="lazy" decoding="async" width={180} height={180} src="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/about-3-1.png" className="attachment-large size-large wp-image-132" alt="" />
              </div>
            </motion.div>

          </div>
        </div>

      </div>
                    </section>
                    <section
                      className="elementor-section elementor-top-section elementor-element elementor-element-5c7b2082 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                      data-id="5c7b2082"
                      data-element_type="section"
                      data-settings='{"background_background":"classic"}'
                    >
                      <div className="elementor-container elementor-column-gap-no">
                        <div
                          className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-73161b29"
                          data-id="73161b29"
                          data-element_type="column"
                        >
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <section
                              className="elementor-section elementor-inner-section elementor-element elementor-element-664fb429 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="664fb429"
                              data-element_type="section"
                            >
                              <div className="elementor-container elementor-column-gap-no">
                                <div
                                  className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-407345c3"
                                  data-id="407345c3"
                                  data-element_type="column"
                                >
                                  <div className="elementor-widget-wrap elementor-element-populated">
                                    <div
                                      className="elementor-element elementor-element-2c156a2e elementor-widget elementor-widget-heading"
                                      data-id="2c156a2e"
                                      data-element_type="widget"
                                      data-widget_type="heading.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <h2 className="elementor-heading-title elementor-size-default">
                                          Features Services
                                        </h2>{" "}
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-28b8fdb7 elementor-widget elementor-widget-heading"
                                      data-id="28b8fdb7"
                                      data-element_type="widget"
                                      data-widget_type="heading.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <h2 className="elementor-heading-title elementor-size-default">
                                          A wide range of waste disposal
                                          services
                                        </h2>{" "}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                            <section
                              className="elementor-section elementor-inner-section elementor-element elementor-element-1709de61 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="1709de61"
                              data-element_type="section"
                            >
                              <div className="elementor-container elementor-column-gap-no">
                                <div
                                  className="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-41eb6225 wastix_block_01"
                                  data-id="41eb6225"
                                  data-element_type="column"
                                  data-settings='{"background_background":"classic"}'
                                >
                                  <div className="elementor-widget-wrap elementor-element-populated">
                                    <div
                                      className="elementor-element elementor-element-1e390da2 wastix_img_box_01 elementor-widget elementor-widget-image"
                                      data-id="1e390da2"
                                      data-element_type="widget"
                                      data-widget_type="image.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <img
                                          loading="lazy"
                                          decoding="async"
                                          width={226}
                                          height={203}
                                          src="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-18.png"
                                          className="attachment-large size-large wp-image-550"
                                          alt=""
                                        />{" "}
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-23aefcaa elementor-absolute wastix_icon_02 elementor-view-default elementor-widget elementor-widget-icon"
                                      data-id="23aefcaa"
                                      data-element_type="widget"
                                      data-settings='{"_position":"absolute"}'
                                      data-widget_type="icon.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <div className="elementor-icon-wrapper">
                                          <div className="elementor-icon">
                                            <svg
                                              aria-hidden="true"
                                              className="e-font-icon-svg e-fas-bacteria"
                                              viewBox="0 0 640 512"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path d="M272.35,226.4A17.71,17.71,0,0,0,281.46,203l-4-9.08a121.29,121.29,0,0,1,12.36-3.08A83.34,83.34,0,0,0,323.57,177l10,9a17.76,17.76,0,1,0,23.92-26.27l-9.72-8.76a83.12,83.12,0,0,0,11.65-48.18l11.85-3.51a17.73,17.73,0,1,0-10.15-34l-11.34,3.36a84,84,0,0,0-36.38-35.57l2.84-10.85a17.8,17.8,0,0,0-34.47-8.93l-2.82,10.78a83.25,83.25,0,0,0-16.74,1.1C250.83,27,240,30.22,229.1,33.39l-3.38-9.46a17.8,17.8,0,0,0-33.56,11.89l3.49,9.8a286.74,286.74,0,0,0-43.94,23.57l-6.32-8.43a17.9,17.9,0,0,0-24.94-3.6A17.69,17.69,0,0,0,116.84,82l6.45,8.61a286.59,286.59,0,0,0-34.95,35.33l-8.82-6.42a17.84,17.84,0,0,0-24.89,3.86,17.66,17.66,0,0,0,3.88,24.77l8.88,6.47a286.6,286.6,0,0,0-23,43.91l-10.48-3.59a17.73,17.73,0,1,0-11.59,33.52L32.67,232c-2.79,10-5.79,19.84-7.52,30.22a83.16,83.16,0,0,0-.82,19l-11.58,3.43a17.73,17.73,0,1,0,10.13,34l11.27-3.33a83.51,83.51,0,0,0,36.39,35.43l-2.88,11.06a17.81,17.81,0,0,0,34.48,8.92l2.87-11c1,0,2.07.26,3.1.26a83.39,83.39,0,0,0,45.65-13.88l8.59,8.8a17.77,17.77,0,0,0,25.56-24.7l-9.14-9.37a83.41,83.41,0,0,0,12.08-31.05,119.08,119.08,0,0,1,3.87-15.53l9,4.22a17.74,17.74,0,1,0,15.15-32.09l-8.8-4.11c.67-1,1.2-2.08,1.9-3.05a119.89,119.89,0,0,1,7.87-9.41,121.73,121.73,0,0,1,11.65-11.4,119.49,119.49,0,0,1,9.94-7.82c1.12-.77,2.32-1.42,3.47-2.15l3.92,8.85a17.86,17.86,0,0,0,16.32,10.58A18.14,18.14,0,0,0,272.35,226.4ZM128,256a32,32,0,1,1,32-32A32,32,0,0,1,128,256Zm80-96a16,16,0,1,1,16-16A16,16,0,0,1,208,160Zm431.26,45.3a17.79,17.79,0,0,0-17.06-12.69,17.55,17.55,0,0,0-5.08.74l-11.27,3.33a83.61,83.61,0,0,0-36.39-35.43l2.88-11.06a17.81,17.81,0,0,0-34.48-8.91l-2.87,11c-1,0-2.07-.26-3.1-.26a83.32,83.32,0,0,0-45.65,13.89l-8.59-8.81a17.77,17.77,0,0,0-25.56,24.7l9.14,9.37a83.28,83.28,0,0,0-12.08,31.06,119.34,119.34,0,0,1-3.87,15.52l-9-4.22a17.74,17.74,0,1,0-15.15,32.09l8.8,4.11c-.67,1-1.2,2.08-1.89,3.05a117.71,117.71,0,0,1-7.94,9.47,119,119,0,0,1-11.57,11.33,121.59,121.59,0,0,1-10,7.83c-1.12.77-2.32,1.42-3.47,2.15l-3.92-8.85a17.86,17.86,0,0,0-16.32-10.58,18.14,18.14,0,0,0-7.18,1.5A17.71,17.71,0,0,0,358.54,309l4,9.08a118.71,118.71,0,0,1-12.36,3.08,83.34,83.34,0,0,0-33.77,13.9l-10-9a17.77,17.77,0,1,0-23.92,26.28l9.72,8.75a83.12,83.12,0,0,0-11.65,48.18l-11.86,3.51a17.73,17.73,0,1,0,10.16,34l11.34-3.36A84,84,0,0,0,326.61,479l-2.84,10.85a17.8,17.8,0,0,0,34.47,8.93L361.06,488a83.3,83.3,0,0,0,16.74-1.1c11.37-1.89,22.24-5.07,33.1-8.24l3.38,9.46a17.8,17.8,0,0,0,33.56-11.89l-3.49-9.79a287.66,287.66,0,0,0,43.94-23.58l6.32,8.43a17.88,17.88,0,0,0,24.93,3.6A17.67,17.67,0,0,0,523.16,430l-6.45-8.61a287.37,287.37,0,0,0,34.95-35.34l8.82,6.42a17.76,17.76,0,1,0,21-28.63l-8.88-6.46a287.17,287.17,0,0,0,23-43.92l10.48,3.59a17.73,17.73,0,1,0,11.59-33.52L607.33,280c2.79-10,5.79-19.84,7.52-30.21a83.27,83.27,0,0,0,.82-19.05l11.58-3.43A17.7,17.7,0,0,0,639.26,205.3ZM416,416a32,32,0,1,1,32-32A32,32,0,0,1,416,416Z" />
                                            </svg>{" "}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-69b0dfc elementor-absolute wastix_img_box_hover_01 elementor-widget elementor-widget-image"
                                      data-id="69b0dfc"
                                      data-element_type="widget"
                                      data-settings='{"_position":"absolute"}'
                                      data-widget_type="image.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <img
                                          loading="lazy"
                                          decoding="async"
                                          width={226}
                                          height={203}
                                          src="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-19.png"
                                          className="attachment-large size-large wp-image-551"
                                          alt=""
                                        />{" "}
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-1906861e elementor-align-center elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                                      data-id="1906861e"
                                      data-element_type="widget"
                                      data-widget_type="icon-list.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <ul className="elementor-icon-list-items">
                                          <li className="elementor-icon-list-item">
                                            <a href="https://23july.hostlin.com/wastix/garbage-pickup/">
                                              <span className="elementor-icon-list-text">
                                                Garbage Pickup
                                              </span>
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-2981e6ba elementor-widget elementor-widget-text-editor"
                                      data-id="2981e6ba"
                                      data-element_type="widget"
                                      data-widget_type="text-editor.default"
                                    >
                                      <div className="elementor-widget-container">
                                        Regular garbage pickup to maintain clean
                                        nature
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-46c9f84 elementor-view-framed wastix_btn_box_shadow_01 elementor-widget__width-initial elementor-shape-circle elementor-widget elementor-widget-icon"
                                      data-id="46c9f84"
                                      data-element_type="widget"
                                      data-widget_type="icon.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <div className="elementor-icon-wrapper">
                                          <Link
                                            className="elementor-icon"
                                            to="/solid-waste-management"
                                          >
                                            <svg
                                              aria-hidden="true"
                                              className="e-font-icon-svg e-fas-arrow-right"
                                              viewBox="0 0 448 512"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z" />
                                            </svg>{" "}
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-24e47991 wastix_block_01"
                                  data-id="24e47991"
                                  data-element_type="column"
                                  data-settings='{"background_background":"classic"}'
                                >
                                  <div className="elementor-widget-wrap elementor-element-populated">
                                    <div
                                      className="elementor-element elementor-element-756903f wastix_img_box_01 elementor-widget elementor-widget-image"
                                      data-id="756903f"
                                      data-element_type="widget"
                                      data-widget_type="image.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <img
                                          loading="lazy"
                                          decoding="async"
                                          width={226}
                                          height={203}
                                          src="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-18.png"
                                          className="attachment-large size-large wp-image-550"
                                          alt=""
                                        />{" "}
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-232606a5 elementor-absolute wastix_icon_02 elementor-view-default elementor-widget elementor-widget-icon"
                                      data-id="232606a5"
                                      data-element_type="widget"
                                      data-settings='{"_position":"absolute"}'
                                      data-widget_type="icon.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <div className="elementor-icon-wrapper">
                                          <div className="elementor-icon">
                                            <svg
                                              aria-hidden="true"
                                              className="e-font-icon-svg e-fas-cat"
                                              viewBox="0 0 512 512"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path d="M290.59 192c-20.18 0-106.82 1.98-162.59 85.95V192c0-52.94-43.06-96-96-96-17.67 0-32 14.33-32 32s14.33 32 32 32c17.64 0 32 14.36 32 32v256c0 35.3 28.7 64 64 64h176c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-32l128-96v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V289.86c-10.29 2.67-20.89 4.54-32 4.54-61.81 0-113.52-44.05-125.41-102.4zM448 96h-64l-64-64v134.4c0 53.02 42.98 96 96 96s96-42.98 96-96V32l-64 64zm-72 80c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm80 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z" />
                                            </svg>{" "}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-4d651ff5 elementor-absolute wastix_img_box_hover_01 elementor-widget elementor-widget-image"
                                      data-id="4d651ff5"
                                      data-element_type="widget"
                                      data-settings='{"_position":"absolute"}'
                                      data-widget_type="image.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <img
                                          loading="lazy"
                                          decoding="async"
                                          width={226}
                                          height={203}
                                          src="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-19.png"
                                          className="attachment-large size-large wp-image-551"
                                          alt=""
                                        />{" "}
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-7c906ef1 elementor-align-center elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                                      data-id="7c906ef1"
                                      data-element_type="widget"
                                      data-widget_type="icon-list.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <ul className="elementor-icon-list-items">
                                          <li className="elementor-icon-list-item">
                                            <a href="https://23july.hostlin.com/wastix/dumpster-rental/">
                                              <span className="elementor-icon-list-text">
                                                Dumpster Rental
                                              </span>
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-358493d7 elementor-widget elementor-widget-text-editor"
                                      data-id="358493d7"
                                      data-element_type="widget"
                                      data-widget_type="text-editor.default"
                                    >
                                      <div className="elementor-widget-container">
                                        Easy dumpster rentals for hassle-free
                                        waste removal
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-6bca55d1 elementor-view-framed wastix_btn_box_shadow_01 elementor-widget__width-initial elementor-shape-circle elementor-widget elementor-widget-icon"
                                      data-id="6bca55d1"
                                      data-element_type="widget"
                                      data-widget_type="icon.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <div className="elementor-icon-wrapper">
                                          <Link
                                            className="elementor-icon"
                                            to="/construction"
                                          >
                                            <svg
                                              aria-hidden="true"
                                              className="e-font-icon-svg e-fas-arrow-right"
                                              viewBox="0 0 448 512"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z" />
                                            </svg>{" "}
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-5e1532d5 wastix_block_01"
                                  data-id="5e1532d5"
                                  data-element_type="column"
                                  data-settings='{"background_background":"classic"}'
                                >
                                  <div className="elementor-widget-wrap elementor-element-populated">
                                    <div
                                      className="elementor-element elementor-element-6410fbbf wastix_img_box_01 elementor-widget elementor-widget-image"
                                      data-id="6410fbbf"
                                      data-element_type="widget"
                                      data-widget_type="image.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <img
                                          loading="lazy"
                                          decoding="async"
                                          width={226}
                                          height={203}
                                          src="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-18.png"
                                          className="attachment-large size-large wp-image-550"
                                          alt=""
                                        />{" "}
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-82e1810 elementor-absolute wastix_icon_02 elementor-view-default elementor-widget elementor-widget-icon"
                                      data-id="82e1810"
                                      data-element_type="widget"
                                      data-settings='{"_position":"absolute"}'
                                      data-widget_type="icon.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <div className="elementor-icon-wrapper">
                                          <div className="elementor-icon">
                                            <svg
                                              aria-hidden="true"
                                              className="e-font-icon-svg e-fas-recycle"
                                              viewBox="0 0 512 512"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path d="M184.561 261.903c3.232 13.997-12.123 24.635-24.068 17.168l-40.736-25.455-50.867 81.402C55.606 356.273 70.96 384 96.012 384H148c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12H96.115c-75.334 0-121.302-83.048-81.408-146.88l50.822-81.388-40.725-25.448c-12.081-7.547-8.966-25.961 4.879-29.158l110.237-25.45c8.611-1.988 17.201 3.381 19.189 11.99l25.452 110.237zm98.561-182.915l41.289 66.076-40.74 25.457c-12.051 7.528-9 25.953 4.879 29.158l110.237 25.45c8.672 1.999 17.215-3.438 19.189-11.99l25.45-110.237c3.197-13.844-11.99-24.719-24.068-17.168l-40.687 25.424-41.263-66.082c-37.521-60.033-125.209-60.171-162.816 0l-17.963 28.766c-3.51 5.62-1.8 13.021 3.82 16.533l33.919 21.195c5.62 3.512 13.024 1.803 16.536-3.817l17.961-28.743c12.712-20.341 41.973-19.676 54.257-.022zM497.288 301.12l-27.515-44.065c-3.511-5.623-10.916-7.334-16.538-3.821l-33.861 21.159c-5.62 3.512-7.33 10.915-3.818 16.536l27.564 44.112c13.257 21.211-2.057 48.96-27.136 48.96H320V336.02c0-14.213-17.242-21.383-27.313-11.313l-80 79.981c-6.249 6.248-6.249 16.379 0 22.627l80 79.989C302.689 517.308 320 510.3 320 495.989V448h95.88c75.274 0 121.335-82.997 81.408-146.88z" />
                                            </svg>{" "}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-f2e0d0b elementor-absolute wastix_img_box_hover_01 elementor-widget elementor-widget-image"
                                      data-id="f2e0d0b"
                                      data-element_type="widget"
                                      data-settings='{"_position":"absolute"}'
                                      data-widget_type="image.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <img
                                          loading="lazy"
                                          decoding="async"
                                          width={226}
                                          height={203}
                                          src="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-19.png"
                                          className="attachment-large size-large wp-image-551"
                                          alt=""
                                        />{" "}
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-2dc0489f elementor-align-center elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                                      data-id="2dc0489f"
                                      data-element_type="widget"
                                      data-widget_type="icon-list.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <ul className="elementor-icon-list-items">
                                          <li className="elementor-icon-list-item">
                                            <a href="https://23july.hostlin.com/wastix/waste-collection/">
                                              <span className="elementor-icon-list-text">
                                                Waste Collection
                                              </span>
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-4ce185b1 elementor-widget elementor-widget-text-editor"
                                      data-id="4ce185b1"
                                      data-element_type="widget"
                                      data-widget_type="text-editor.default"
                                    >
                                      <div className="elementor-widget-container">
                                        Reliable community waste collection
                                        services
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-1592ccf8 elementor-view-framed wastix_btn_box_shadow_01 elementor-widget__width-initial elementor-shape-circle elementor-widget elementor-widget-icon"
                                      data-id="1592ccf8"
                                      data-element_type="widget"
                                      data-widget_type="icon.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <div className="elementor-icon-wrapper">
                                          <Link
                                            className="elementor-icon"
                                            to="/bio-medical-waste-management"
                                          >
                                            <svg
                                              aria-hidden="true"
                                              className="e-font-icon-svg e-fas-arrow-right"
                                              viewBox="0 0 448 512"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z" />
                                            </svg>{" "}
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-5574121c wastix_block_01"
                                  data-id="5574121c"
                                  data-element_type="column"
                                  data-settings='{"background_background":"classic"}'
                                >
                                  <div className="elementor-widget-wrap elementor-element-populated">
                                    <div
                                      className="elementor-element elementor-element-1ce7633b wastix_img_box_01 elementor-widget elementor-widget-image"
                                      data-id="1ce7633b"
                                      data-element_type="widget"
                                      data-widget_type="image.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <img
                                          loading="lazy"
                                          decoding="async"
                                          width={226}
                                          height={203}
                                          src="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-18.png"
                                          className="attachment-large size-large wp-image-550"
                                          alt=""
                                        />{" "}
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-487ac974 elementor-absolute wastix_icon_02 elementor-view-default elementor-widget elementor-widget-icon"
                                      data-id="487ac974"
                                      data-element_type="widget"
                                      data-settings='{"_position":"absolute"}'
                                      data-widget_type="icon.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <div className="elementor-icon-wrapper">
                                          <div className="elementor-icon">
                                            <svg
                                              aria-hidden="true"
                                              className="e-font-icon-svg e-fab-canadian-maple-leaf"
                                              viewBox="0 0 512 512"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path d="M383.8 351.7c2.5-2.5 105.2-92.4 105.2-92.4l-17.5-7.5c-10-4.9-7.4-11.5-5-17.4 2.4-7.6 20.1-67.3 20.1-67.3s-47.7 10-57.7 12.5c-7.5 2.4-10-2.5-12.5-7.5s-15-32.4-15-32.4-52.6 59.9-55.1 62.3c-10 7.5-20.1 0-17.6-10 0-10 27.6-129.6 27.6-129.6s-30.1 17.4-40.1 22.4c-7.5 5-12.6 5-17.6-5C293.5 72.3 255.9 0 255.9 0s-37.5 72.3-42.5 79.8c-5 10-10 10-17.6 5-10-5-40.1-22.4-40.1-22.4S183.3 182 183.3 192c2.5 10-7.5 17.5-17.6 10-2.5-2.5-55.1-62.3-55.1-62.3S98.1 167 95.6 172s-5 9.9-12.5 7.5C73 177 25.4 167 25.4 167s17.6 59.7 20.1 67.3c2.4 6 5 12.5-5 17.4L23 259.3s102.6 89.9 105.2 92.4c5.1 5 10 7.5 5.1 22.5-5.1 15-10.1 35.1-10.1 35.1s95.2-20.1 105.3-22.6c8.7-.9 18.3 2.5 18.3 12.5S241 512 241 512h30s-5.8-102.7-5.8-112.8 9.5-13.4 18.4-12.5c10 2.5 105.2 22.6 105.2 22.6s-5-20.1-10-35.1 0-17.5 5-22.5z" />
                                            </svg>{" "}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-6d37bac3 elementor-absolute wastix_img_box_hover_01 elementor-widget elementor-widget-image"
                                      data-id="6d37bac3"
                                      data-element_type="widget"
                                      data-settings='{"_position":"absolute"}'
                                      data-widget_type="image.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <img
                                          loading="lazy"
                                          decoding="async"
                                          width={226}
                                          height={203}
                                          src="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-19.png"
                                          className="attachment-large size-large wp-image-551"
                                          alt=""
                                        />{" "}
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-3e138b80 elementor-align-center elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                                      data-id="3e138b80"
                                      data-element_type="widget"
                                      data-widget_type="icon-list.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <ul className="elementor-icon-list-items">
                                          <li className="elementor-icon-list-item">
                                            <a href="https://23july.hostlin.com/wastix/recycling-service/">
                                              <span className="elementor-icon-list-text">
                                                {" "}
                                                Recycling Service
                                              </span>
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-54ef9e17 elementor-widget elementor-widget-text-editor"
                                      data-id="54ef9e17"
                                      data-element_type="widget"
                                      data-widget_type="text-editor.default"
                                    >
                                      <div className="elementor-widget-container">
                                        Green recycling solutions make waste
                                        sustainable
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-2e0c94d4 elementor-view-framed wastix_btn_box_shadow_01 elementor-widget__width-initial elementor-shape-circle elementor-widget elementor-widget-icon"
                                      data-id="2e0c94d4"
                                      data-element_type="widget"
                                      data-widget_type="icon.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <div className="elementor-icon-wrapper">
                                          <Link
                                            className="elementor-icon"
                                            to="/bio-medical-waste-management"
                                          >
                                            <svg
                                              aria-hidden="true"
                                              className="e-font-icon-svg e-fas-arrow-right"
                                              viewBox="0 0 448 512"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z" />
                                            </svg>{" "}
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                            <div
                              className="elementor-element elementor-element-64cf1fb5  wastix_btn_01 elementor-mobile-align-center elementor-widget-mobile__width-inherit elementor-align-center elementor-widget elementor-widget-button"
                              data-id="64cf1fb5"
                              data-element_type="widget"
                              data-widget_type="button.default"
                            >
                              <div className="elementor-widget-container">
                                <div className="elementor-button-wrapper">
                                  <a
                                    className="elementor-button elementor-button-link elementor-size-sm"
                                    href="#"
                                  >
                                    <span className="elementor-button-content-wrapper">
                                      <span className="elementor-button-text">
                                        More Services
                                      </span>
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                    <section
                      className="elementor-section elementor-top-section elementor-element elementor-element-7f267a4b elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                      data-id="7f267a4b"
                      data-element_type="section"
                      data-settings='{"background_background":"classic"}'
                    >
                      <div className="elementor-container elementor-column-gap-no">
                        <div
                          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-7d19dbbd"
                          data-id="7d19dbbd"
                          data-element_type="column"
                        >
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div
                              className="elementor-element elementor-element-5c694ad3 elementor-widget__width-auto elementor-absolute wastix_img_animation_03 elementor-widget elementor-widget-image"
                              data-id="5c694ad3"
                              data-element_type="widget"
                              data-settings='{"_position":"absolute"}'
                              data-widget_type="image.default"
                            >
                              <div className="elementor-widget-container">
                                <img
                                  loading="lazy"
                                  decoding="async"
                                  width={148}
                                  height={149}
                                  src="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-22-1.png"
                                  className="attachment-large size-large wp-image-660"
                                  alt=""
                                  srcSet="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-22-1.png 148w, https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-22-1-100x100.png 100w"
                                  sizes="(max-width: 148px) 100vw, 148px"
                                />{" "}
                              </div>
                            </div>
                            <div
                              className="elementor-element elementor-element-41ddfc93 elementor-widget__width-auto elementor-absolute wastix_img_animation_02 elementor-widget elementor-widget-image"
                              data-id="41ddfc93"
                              data-element_type="widget"
                              data-settings='{"_position":"absolute"}'
                              data-widget_type="image.default"
                            >
                              <div className="elementor-widget-container">
                                <img
                                  loading="lazy"
                                  decoding="async"
                                  width={113}
                                  height={108}
                                  src="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-8.png"
                                  className="attachment-large size-large wp-image-240"
                                  alt=""
                                />{" "}
                              </div>
                            </div>
                            <div
                              className="elementor-element elementor-element-361d44ee elementor-widget elementor-widget-image"
                              data-id="361d44ee"
                              data-element_type="widget"
                              data-widget_type="image.default"
                            >
                              <div className="elementor-widget-container">
                                <img
                                  loading="lazy"
                                  decoding="async"
                                  width={523}
                                  height={384}
                                  src="/Truck11.png"
                                  className="attachment-large size-large wp-image-720"
                                  alt=""
                                />{" "}
                              </div>
                            </div>
                            <div
                              className="elementor-element elementor-element-50715e33 elementor-widget__width-auto elementor-absolute wastix_img_animation_03 elementor-widget elementor-widget-image"
                              data-id="50715e33"
                              data-element_type="widget"
                              data-settings='{"_position":"absolute"}'
                              data-widget_type="image.default"
                            >
                              <div className="elementor-widget-container">
                                <img
                                  loading="lazy"
                                  decoding="async"
                                  width={148}
                                  height={149}
                                  src="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-22.png"
                                  className="attachment-large size-large wp-image-656"
                                  alt=""
                                  srcSet="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-22.png 148w, https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-22-100x100.png 100w"
                                  sizes="(max-width: 148px) 100vw, 148px"
                                />{" "}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-5fc596db"
                          data-id="5fc596db"
                          data-element_type="column"
                        >
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div
                              className="elementor-element elementor-element-dc23e8b elementor-widget__width-auto elementor-absolute wastix_img_animation_03 elementor-widget elementor-widget-image"
                              data-id="dc23e8b"
                              data-element_type="widget"
                              data-settings='{"_position":"absolute"}'
                              data-widget_type="image.default"
                            >
                              <div className="elementor-widget-container">
                                <img
                                  loading="lazy"
                                  decoding="async"
                                  width={148}
                                  height={149}
                                  src="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-22-1.png"
                                  className="attachment-large size-large wp-image-660"
                                  alt=""
                                  srcSet="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-22-1.png 148w, https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-22-1-100x100.png 100w"
                                  sizes="(max-width: 148px) 100vw, 148px"
                                />{" "}
                              </div>
                            </div>
                            <div
                              className="elementor-element elementor-element-65733ab6 elementor-widget__width-initial elementor-widget elementor-widget-heading"
                              data-id="65733ab6"
                              data-element_type="widget"
                              data-widget_type="heading.default"
                            >
                              <div className="elementor-widget-container">
                                <h2 className="elementor-heading-title elementor-size-default">
                                  Become our customer &amp; get special service
                                </h2>{" "}
                              </div>
                            </div>
                            <div
                              className="elementor-element elementor-element-3fef1aa6  wastix_btn_01 elementor-widget__width-auto elementor-mobile-align-justify elementor-widget-mobile__width-inherit elementor-widget elementor-widget-button"
                              data-id="3fef1aa6"
                              data-element_type="widget"
                              data-widget_type="button.default"
                            >
                              <div className="elementor-widget-container">
                                <div className="elementor-button-wrapper">
                                  <a
                                    className="elementor-button elementor-button-link elementor-size-sm"
                                    href="https://23july.hostlin.com/wastix/about-us/"
                                  >
                                    <span className="elementor-button-content-wrapper">
                                      <span className="elementor-button-text">
                                        Request A Pickup
                                      </span>
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>

                            <div
                              className="elementor-element elementor-element-205c6ffc elementor-widget__width-auto elementor-absolute icon_animation_01 elementor-widget elementor-widget-image"
                              data-id="205c6ffc"
                              data-element_type="widget"
                              data-settings='{"_position":"absolute"}'
                              data-widget_type="image.default"
                            >
                              <div className="elementor-widget-container">
                                <img
                                  loading="lazy"
                                  decoding="async"
                                  width={115}
                                  height={115}
                                  src="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-24.png"
                                  className="attachment-large size-large wp-image-718"
                                  alt=""
                                  srcSet="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-24.png 115w, https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-24-100x100.png 100w"
                                  sizes="(max-width: 115px) 100vw, 115px"
                                />{" "}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
               
                    <section
                      className="elementor-section elementor-top-section elementor-element elementor-element-477e95bf elementor-section-boxed elementor-section-height-default elementor-section-height-default "
                      data-id="477e95bf"
                      data-element_type="section"
                      data-settings='{"background_background":"classic"}'
                    >
                      <div className="elementor-background-overlay" />
                      <div className="elementor-container elementor-column-gap-no">
                        <div
                          className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-24129fd0"
                          data-id="24129fd0"
                          data-element_type="column"
                        >
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <section
                              className="elementor-section elementor-inner-section elementor-element elementor-element-428dfb3d elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="428dfb3d"
                              data-element_type="section"
                              data-settings='{"background_background":"classic"}'
                            >
                              <div className="elementor-background-overlay" />
                              <div className="elementor-container elementor-column-gap-no">
                                <div
                                  className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-3d3daa1f"
                                  data-id="3d3daa1f"
                                  data-element_type="column"
                                >
                                  <div className="elementor-widget-wrap elementor-element-populated">
                                    <div
                                      className="elementor-element elementor-element-1c20f6dd elementor-widget elementor-widget-heading"
                                      data-id="1c20f6dd"
                                      data-element_type="widget"
                                      data-widget_type="heading.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <h2 className="elementor-heading-title elementor-size-default">
                                          Recycle Materials
                                        </h2>{" "}
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-3ebf5523 elementor-widget elementor-widget-heading"
                                      data-id="3ebf5523"
                                      data-element_type="widget"
                                      data-widget_type="heading.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <h2 className="elementor-heading-title elementor-size-default">
                                          We collect, recycle &amp; disposal all
                                          materials
                                        </h2>{" "}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-2331484e"
                                  data-id="2331484e"
                                  data-element_type="column"
                                >
                                  <div className="elementor-widget-wrap elementor-element-populated">
                                    <div
                                      className="elementor-element elementor-element-3433d735 wastix_img_animation_02 elementor-widget__width-auto elementor-widget elementor-widget-image"
                                      data-id="3433d735"
                                      data-element_type="widget"
                                      data-widget_type="image.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <img
                                          loading="lazy"
                                          decoding="async"
                                          width={113}
                                          height={108}
                                          src="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-10.png"
                                          className="attachment-large size-large wp-image-269"
                                          alt=""
                                        />{" "}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-6f4b4fdf"
                                  data-id="6f4b4fdf"
                                  data-element_type="column"
                                >
                                  <div className="elementor-widget-wrap elementor-element-populated">
                                    <div
                                      className="elementor-element elementor-element-d77722b elementor-align-left icon_wastix_01 elementor-widget__width-auto elementor-widget-tablet__width-inherit elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                                      data-id="d77722b"
                                      data-element_type="widget"
                                      data-widget_type="icon-list.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <ul className="elementor-icon-list-items">
                                          <li className="elementor-icon-list-item">
                                            <a href="#">
                                              <span className="elementor-icon-list-icon">
                                                <svg
                                                  aria-hidden="true"
                                                  className="e-font-icon-svg e-fas-check"
                                                  viewBox="0 0 512 512"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" />
                                                </svg>{" "}
                                              </span>
                                              <span className="elementor-icon-list-text">
                                                Steel
                                              </span>
                                            </a>
                                          </li>
                                          <li className="elementor-icon-list-item">
                                            <a href="#">
                                              <span className="elementor-icon-list-icon">
                                                <svg
                                                  aria-hidden="true"
                                                  className="e-font-icon-svg e-fas-check"
                                                  viewBox="0 0 512 512"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" />
                                                </svg>{" "}
                                              </span>
                                              <span className="elementor-icon-list-text">
                                                Plastic
                                              </span>
                                            </a>
                                          </li>
                                          <li className="elementor-icon-list-item">
                                            <a href="#">
                                              <span className="elementor-icon-list-icon">
                                                <svg
                                                  aria-hidden="true"
                                                  className="e-font-icon-svg e-fas-check"
                                                  viewBox="0 0 512 512"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" />
                                                </svg>{" "}
                                              </span>
                                              <span className="elementor-icon-list-text">
                                                Lights &amp; Bulbs
                                              </span>
                                            </a>
                                          </li>
                                          <li className="elementor-icon-list-item">
                                            <a href="#">
                                              <span className="elementor-icon-list-icon">
                                                <svg
                                                  aria-hidden="true"
                                                  className="e-font-icon-svg e-fas-check"
                                                  viewBox="0 0 512 512"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" />
                                                </svg>{" "}
                                              </span>
                                              <span className="elementor-icon-list-text">
                                                Books &amp; Papers
                                              </span>
                                            </a>
                                          </li>
                                          <li className="elementor-icon-list-item">
                                            <a href="#">
                                              <span className="elementor-icon-list-icon">
                                                <svg
                                                  aria-hidden="true"
                                                  className="e-font-icon-svg e-fas-check"
                                                  viewBox="0 0 512 512"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" />
                                                </svg>{" "}
                                              </span>
                                              <span className="elementor-icon-list-text">
                                                Bottles
                                              </span>
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-71ab3496 elementor-align-left icon_wastix_01 elementor-widget__width-auto elementor-widget-tablet__width-inherit elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                                      data-id="71ab3496"
                                      data-element_type="widget"
                                      data-widget_type="icon-list.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <ul className="elementor-icon-list-items">
                                          <li className="elementor-icon-list-item">
                                            <a href="#">
                                              <span className="elementor-icon-list-icon">
                                                <svg
                                                  aria-hidden="true"
                                                  className="e-font-icon-svg e-fas-check"
                                                  viewBox="0 0 512 512"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" />
                                                </svg>{" "}
                                              </span>
                                              <span className="elementor-icon-list-text">
                                                Food &amp; Grocery
                                              </span>
                                            </a>
                                          </li>
                                          <li className="elementor-icon-list-item">
                                            <a href="#">
                                              <span className="elementor-icon-list-icon">
                                                <svg
                                                  aria-hidden="true"
                                                  className="e-font-icon-svg e-fas-check"
                                                  viewBox="0 0 512 512"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" />
                                                </svg>{" "}
                                              </span>
                                              <span className="elementor-icon-list-text">
                                                Common Waste
                                              </span>
                                            </a>
                                          </li>
                                          <li className="elementor-icon-list-item">
                                            <a href="#">
                                              <span className="elementor-icon-list-icon">
                                                <svg
                                                  aria-hidden="true"
                                                  className="e-font-icon-svg e-fas-check"
                                                  viewBox="0 0 512 512"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" />
                                                </svg>{" "}
                                              </span>
                                              <span className="elementor-icon-list-text">
                                                Newspaper
                                              </span>
                                            </a>
                                          </li>
                                          <li className="elementor-icon-list-item">
                                            <a href="#">
                                              <span className="elementor-icon-list-icon">
                                                <svg
                                                  aria-hidden="true"
                                                  className="e-font-icon-svg e-fas-check"
                                                  viewBox="0 0 512 512"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" />
                                                </svg>{" "}
                                              </span>
                                              <span className="elementor-icon-list-text">
                                                Food &amp; Grocery
                                              </span>
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                    </section>
                    
                   
                  </div>
                </div>
                <div className="clearfix" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default About;
